module.exports = __webpack_public_path__ + "static/img/brees-2004-slide-2.8dff50b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2004-slide-2.jpg
// module id = xqyX
// module chunks = 1